import { lookup } from 'mime-types';

export const MAIL_ATTACHMENT_ATTACHED = 'attachment';
export const MAIL_ATTACHMENT_INLINE = 'inline';

export type MAIL_ATTACHMENT_ATTACHED_TYPE = typeof MAIL_ATTACHMENT_ATTACHED;
export type MAIL_ATTACHMENT_INLINE_TYPE = typeof MAIL_ATTACHMENT_INLINE;

export type Attachment = {
  content: string;
  type: string;
  fileName: string;
  disposition: MAIL_ATTACHMENT_ATTACHED_TYPE | MAIL_ATTACHMENT_INLINE_TYPE;
  contentId?: string;
};

export const getDataUrlForAttachment = (attachment: Attachment) => {
  const mime = lookup(attachment.fileName);

  return `data:${mime};base64,${attachment.content}`;
};

export const getBase64ForFile = (file: File, onlyContent = false) =>
  new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      if (reader.result) {
        const base64 = reader.result.toString();
        onlyContent ? resolve(stripPrefix(base64)) : resolve(base64);
      } else {
        reject('no data found');
      }
    };
    reader.onerror = (error) => reject(error);
  });

export const stripPrefix = (base64: string) => {
  const regex = /[^,]*,(.*)/;
  const result = regex.exec(base64);

  // return the first group => whatever is behind the ',' if there is one found
  return result ? result[1] : base64;
};
